<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit">
    <v-card class="log-device-card">
      <v-progress-linear v-if="isLoader" indeterminate color="primary" class="log-device-card__progress" />
      <div class="log-device-card__header">
        <h2 class="log-device-card__title">{{ message }}</h2>
        <v-btn icon small text @click="close" class="log-device-card__close" aria-label="Закрыть">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="log-device-card__body">
        <v-data-table
          v-if="!isLoader && devices.length > 0"
          class="log-device-card__table"
          :headers="devicesJournalLog"
          :items="devices"
          disable-sort
          :footer-props="{ 'items-per-page-options': [5, 10] }"
          dense
        >
          <template v-slot:item.createdAt="{ item }">
            {{ ruDateFormat(item.created_at) }}
          </template>
          <template v-slot:item.error="{ item }">
            <span
              v-if="item.result && item.result.error"
              class="log-device-card__error-link"
              @click="showErrorModal(item.result.error)"
            >
              {{ item.result.error }}
            </span>
          </template>
          <template v-slot:item.type="{ item }">
            <span v-if="item.type">{{ item.type === 'export_sip' ? 'export_sip' : 'export_rules' }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="log-device-card__status">
                  <v-icon x-small :color="item.status === true ? 'success' : 'error'">mdi-checkbox-blank-circle</v-icon>
                  {{ item.status === true ? 'Выполнен' : 'Ошибка' }}
                </span>
              </template>
              <span>{{ item.status === true ? 'Выполнен' : 'Ошибка' }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon small text color="primary" @click.stop="showInfoModal(item)" title="Подробнее">
              <v-icon small>mdi-eye-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <p v-else-if="!isLoader && devices.length === 0" class="log-device-card__empty">Данные отсутствуют.</p>
      </v-card-text>
    </v-card>

    <!-- Диалог ошибки -->
    <v-dialog v-model="errorModal" persistent max-width="500" content-class="log-device-dialog">
      <v-card class="log-device-dialog__card">
        <div class="log-device-dialog__header">
          <h3 class="log-device-dialog__title">
            <v-icon left color="error">mdi-alert-outline</v-icon>
            Ошибка
          </h3>
          <v-btn icon small text @click="closeErrorModal" aria-label="Закрыть">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="log-device-dialog__body">{{ selectedError }}</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Подробная информация (export_sip) -->
    <v-dialog v-model="dialogInfoExportSip" persistent max-width="560" content-class="log-device-dialog">
      <v-card class="log-device-dialog__card">
        <div class="log-device-dialog__header">
          <h3 class="log-device-dialog__title">Подробная информация</h3>
          <v-btn icon small text @click="dialogInfoExportSip = false" aria-label="Закрыть">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="log-device-dialog__body log-device-dialog__body--list">
          <p v-if="formLogsInfo.id" class="log-device-dialog__row">Номер: {{ formLogsInfo.id }}</p>
          <p v-if="formLogsInfo.Acc1Login" class="log-device-dialog__row">Acc1Login: {{ formLogsInfo.Acc1Login }}</p>
          <p v-if="formLogsInfo.Acc1Password" class="log-device-dialog__row">Acc1Password: {{ formLogsInfo.Acc1Password }}</p>
          <p v-if="formLogsInfo.Acc1RegInterval" class="log-device-dialog__row">Acc1RegInterval: {{ formLogsInfo.Acc1RegInterval }}</p>
          <p v-if="formLogsInfo.Acc1SipTransport" class="log-device-dialog__row">Acc1SipTransport: {{ formLogsInfo.Acc1SipTransport }}</p>
          <p v-if="formLogsInfo.ProxyServerUrl1" class="log-device-dialog__row">ProxyServerUrl1: {{ formLogsInfo.ProxyServerUrl1 }}</p>
          <p v-if="formLogsInfo.Acc1SipServer" class="log-device-dialog__row">Acc1SipServer: {{ formLogsInfo.Acc1SipServer }}</p>
          <p v-if="formLogsInfo.AccName1" class="log-device-dialog__row">AccName1: {{ formLogsInfo.AccName1 }}</p>
          <p v-if="formLogsInfo.AccNumber1" class="log-device-dialog__row">AccNumber1: {{ formLogsInfo.AccNumber1 }}</p>
          <p v-if="formLogsInfo.AccPassword1" class="log-device-dialog__row">AccPassword1: {{ formLogsInfo.AccPassword1 }}</p>
          <p v-if="formLogsInfo.AccPort1" class="log-device-dialog__row">AccPort1: {{ formLogsInfo.AccPort1 }}</p>
          <p v-if="formLogsInfo.AccUser1" class="log-device-dialog__row">AccUser1: {{ formLogsInfo.AccUser1 }}</p>
          <p v-if="formLogsInfo.AccountEnable1" class="log-device-dialog__row">AccountEnable1: {{ formLogsInfo.AccountEnable1 }}</p>
          <p v-if="formLogsInfo.ProxyServerPort1" class="log-device-dialog__row">ProxyServerPort1: {{ formLogsInfo.ProxyServerPort1 }}</p>
          <p v-if="formLogsInfo.cAccountActive" class="log-device-dialog__row">cAccountActive: {{ formLogsInfo.cAccountActive }}</p>
          <p v-if="formLogsInfo.cAccountPwd" class="log-device-dialog__row">cAccountPwd: {{ formLogsInfo.cAccountPwd }}</p>
          <p v-if="formLogsInfo.cFirstSIPServerAddr" class="log-device-dialog__row">cFirstSIPServerAddr: {{ formLogsInfo.cFirstSIPServerAddr }}</p>
          <p v-if="formLogsInfo.cFirstRegisterExpire" class="log-device-dialog__row">cFirstRegisterExpire: {{ formLogsInfo.cFirstRegisterExpire }}</p>
          <p v-if="formLogsInfo.cStunServer" class="log-device-dialog__row">cStunServer: {{ formLogsInfo.cStunServer }}</p>
          <p v-if="formLogsInfo.cUserName" class="log-device-dialog__row">cUserName: {{ formLogsInfo.cUserName }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Подробная информация (export_rules) -->
    <v-dialog v-model="dialogInfoExportRules" persistent max-width="460" content-class="log-device-dialog">
      <v-card class="log-device-dialog__card">
        <div class="log-device-dialog__header">
          <h3 class="log-device-dialog__title">Подробная информация</h3>
          <v-btn icon small text @click="dialogInfoExportRules = false" aria-label="Закрыть">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="log-device-dialog__body">
          <p v-if="formLogsInfo.diapason_from" class="ma-0">Диапазон квартир: {{ getDiapason(formLogsInfo.diapason_from) }}</p>
          <p v-if="formLogsInfo.rulesLength" class="ma-0">Кол-во rules (квартир): {{ formLogsInfo.rulesLength }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  mixins: [ruDateFormatMixin],
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
    },
    message: {
      type: String,
    },
    attPopupEditContent: {
      type: Object,
      default: () => ({
        name: '',
        address: '',
        contacts: '',
      }),
    },
  },
  data: () => ({
    valid: true,
    devices: [],
    formLogsInfo: {
    },
    isLoader: false,
    errorModal: false,
    selectedError: '',
    dialogInfoExportSip: false,
    dialogInfoExportRules: false,
    devicesJournalLog: [
      { text: 'Номер', value: 'id' },
      { text: 'Дата и время', value: 'createdAt' },
      { text: 'Домофон', value: 'doorphone_id' },
      { text: 'IP-адрес', value: 'ip_address' },
      { text: 'Тип', value: 'type' },
      { text: 'Статус', value: 'status' },
      { text: 'Ошибка', value: 'error' },
      { text: '', value: 'actions', sortable: false, width: '80' },
    ],
  }),
  created () {
    this.isLoader = true;
    this.getDeviceLogs(this.id)
      .then((response) => {
        this.devices = response.data;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке');
      })
      .finally(() => {
        this.isLoader = false;
      });
  },
  computed: {
    ...mapGetters({
      deviceLogs: 'DeviceLog/deviceLogs',
    }),
  },
  methods: {
    ...mapActions({
      getDeviceLogs: 'DeviceLog/getDeviceLogs',
      updateManagementGroup: 'GroupManagementCompany/updateManagementGroup',
    }),
    getDiapason (item) {
      let diapason = item.diapason;
      if (this.formLogsInfo.diapason_to > 0) {
        diapason = `${this.formLogsInfo.diapason_from} - ${this.formLogsInfo.diapason_to}`;
      }
      return diapason;
    },
    showErrorModal (error) {
      this.selectedError = error;
      this.errorModal = true;
    },
    showInfoModal (item) {
      if (item.type === 'export_sip') {
        this.formLogsInfo = {
          id: item.id,
          Acc1Login: item.data.Acc1Login,
          Acc1Password: item.data.Acc1Password,
          Acc1RegInterval: item.data.Acc1RegInterval,
          Acc1SipTransport: item.data.Acc1SipTransport,
          ProxyServerUrl1: item.data.ProxyServerUrl1,
          Acc1SipServer: item.data.Acc1SipServer,
          AccName1: item.data.AccName1,
          AccNumber1: item.data.AccNumber1,
          AccPassword1: item.data.AccPassword1,
          AccPort1: item.data.AccPort1,
          AccUser1: item.data.AccUser1,
          AccountEnable1: item.data.AccountEnable1,
          ProxyServerPort1: item.data.ProxyServerPort1,

          cAccountActive: item.data.cAccountActive,
          cAccountPwd: item.data.cAccountPwd,
          cFirstSIPServerAddr: item.data.cFirstSIPServerAddr,
          cFirstRegisterExpire: item.data.cFirstRegisterExpire,
          cStunServer: item.data.cStunServer,
          cUserName: item.data.cUserName,
        };
        this.dialogInfoExportSip = true;
      } else {
        this.formLogsInfo = {
          diapason_from: item.data.diapason_from,
          diapason_to: item.data.diapason_to,
          rulesLength: item.data.rules.length,
        };
        this.dialogInfoExportRules = true;
      }
    },
    closeErrorModal () {
      this.selectedError = '';
      this.errorModal = false;
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.log-device-card {
  border-radius: 12px;
  overflow: hidden;
}

.log-device-card__progress {
  margin: 0;
}

.log-device-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
}

.log-device-card__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.log-device-card__close {
  margin: -8px;
}

.log-device-card__body {
  padding: 16px 24px 24px;
}

.log-device-card__table {
  font-size: 0.875rem;
}

.log-device-card__table ::v-deep table {
  border-radius: 8px;
  overflow: hidden;
}

.log-device-card__error-link {
  color: #d32f2f;
  text-decoration: underline;
  cursor: pointer;
  max-width: 180px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.log-device-card__error-link:hover {
  color: #b71c1c;
}

.log-device-card__status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.log-device-card__empty {
  margin: 0;
  color: #546e7a;
  font-size: 0.9375rem;
}

.log-device-dialog__card {
  border-radius: 12px;
  overflow: hidden;
}

.log-device-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: #f5f7f8;
}

.log-device-dialog__title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #37474f;
  margin: 0;
  display: flex;
  align-items: center;
}

.log-device-dialog__body {
  padding: 20px;
  font-size: 0.9375rem;
  color: #37474f;
  line-height: 1.5;
}

.log-device-dialog__body--list .log-device-dialog__row {
  margin: 0 0 6px 0;
  font-family: monospace;
  font-size: 0.8125rem;
}

.log-device-dialog__body--list .log-device-dialog__row:last-child {
  margin-bottom: 0;
}
</style>
